<form *ngIf="transferCashForm" [formGroup]="transferCashForm">
  <div class="form-group">
    <div class="row">
      <div class="col-lg-6 col-12">
        <div class="form-floating mb-3">
          <input
            type="text"
            formControlName="emailAddress"
            class="form-control rounded font-size-14 position-relative"
            id="emailAddress"
            placeholder="Enter recipient's email"
          />
          <label class="input-label font-size-12 text-white" for="emailAddress">
            {{ 'transfer.credit.email' | translate: { fgbdefault: 'Email Address' } }}</label
          >
        </div>

        <div *ngIf="f.emailAddress.dirty && f.emailAddress.errors" class="alert alert-danger font-size-14">
          <div *ngIf="f.emailAddress.errors.required">
            {{ 'transfer.credit.email.required' | translate: { fgbdefault: 'Email Address is required' } }}
          </div>
          <div *ngIf="f.emailAddress.errors.pattern">
            {{ 'transfer.credit.email.format' | translate: { fgbdefault: 'Email Address format incorrect' } }}
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="form-floating mb-3">
          <input
            currencyMask
            formControlName="amount"
            placeholder="{{ 0 | FortressCurrencyPipe: 'USD' }}"
            id="amount"
            class="form-control rounded font-size-14 position-relative amount-control ml-auto mr-auto"
          />
          <label class="input-label font-size-12 text-white" for="amount">
            {{ 'transfer.credit.amount' | translate: { fgbdefault: 'Amount' } }}</label
          >
        </div>

        <div *ngIf="f.amount.dirty && f.amount.errors" class="alert alert-danger font-size-14">
          <div *ngIf="f.amount.errors.required">
            {{ 'transfer.credit.amount.required' | translate: { fgbdefault: 'Amount is required' } }}
          </div>
          <div *ngIf="f.amount.errors.pattern">
            {{ 'transfer.credit.amount.format' | translate: { fgbdefault: 'Numbers only' } }}
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-12 d-flex justify-content-end">
        <button
          type="submit"
          class="btn btn-send font-size-14 fw-bold text-white bg-primary border-0"
          confirmModal
          [disabled]="!transferCashForm.valid"
          [confirmContent]="confirmContent"
          (confirm)="verifyEmail()"
        >
          {{ 'transfer.credit.send' | translate: { fgbdefault: 'Send' } }}
        </button>
      </div>

      <!--Confirm Modal-->
      <ng-template #confirmContent>
        <div class="transfer-confirm-modal">
          <div class="font-size-14 fw-bold ps-3">{{ 'hawks.transfer.modal.title' | translate }}</div>
          <hr />
          <p class="text-white px-3">
            {{ 'hawks.transfer.modal.confirmation' | translate }}
            <span class="text-white fw-bold">{{ transferCashForm.value.amount | FortressCurrencyPipe: 'USD' }}</span> to
            <span class="text-white fw-bold"> {{ transferCashForm.value.emailAddress }}</span
            >?
          </p>
          <p class="mb-0 text-white px-3 font-size-12">{{ 'transfercash.cannot.recalled' | translate }}</p>
        </div>
      </ng-template>
    </div>

    <!-- Can't Transfer to Self Modal -->
    <ng-template #transferOwnEmail let-modal>
      <div class="modal-body">
        <div class="modal-title fw-bold text-white text-center">
          {{ 'transfer.credit.failed' | translate }}
        </div>
        <p class="mb-1 pt-2 pb-4 font-size-14 text-white">
          {{ 'transfer.credit.failed.self' | translate }}
        </p>
        <div class="w-100 d-flex align-items-center justify-content-center">
          <button
            type="button"
            class="modal-return rounded d-block ml-auto mr-auto bg-primary text-white font-size-14 fw-bold text-center border-0 fail"
            data-dismiss="modal"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
          >
            {{ 'transfer.credit.failed.back' | translate }}
          </button>
        </div>
      </div>
    </ng-template>

    <!-- Transfer Fail Modal -->
    <ng-template #transferFailed let-modal>
      <div class="modal-body">
        <div class="modal-title fw-bold">
          {{ 'transfer.credit.failed' | translate }}
        </div>
        <p class="mb-1 pt-2 pb-4 font-size-14 text-white">
          {{ 'transfer.credit.failed.details' | translate }}
        </p>
        <div class="w-100 d-flex align-items-center justify-content-center">
          <button
            type="button"
            class="modal-return rounded d-block ml-auto mr-auto bg-primary text-white font-size-14 fw-bold text-center border-0 fail"
            data-dismiss="modal"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
          >
            {{ 'transfer.credit.failed.back' | translate }}
          </button>
        </div>
      </div>
    </ng-template>

    <!-- Not Enough Funds Modal -->
    <ng-template #invalidFunds let-modal>
      <div class="modal-body">
        <p class="m-4 font-size-14 text-white fw-bold">
          {{ 'transfer.credit.failed.send.to' | translate }}
          <span class="text-success">{{ transferCashForm.value.emailAddress }}</span>
          {{ 'transfer.credit.failed.send.amount' | translate }}
          <span class="text-primary">{{ transferCashForm.value.amount | FortressCurrencyPipe: 'USD' }}</span>
        </p>
        <div class="w-100 d-flex align-items-center justify-content-center">
          <button
            type="button"
            class="modal-return rounded d-block ml-auto mr-auto bg-primary text-white font-size-14 fw-bold text-center border-0"
            data-dismiss="modal"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
          >
            {{ 'transfer.credit.return' | translate: { fgbdefault: 'Return to Transfer Credit' } }}
          </button>
        </div>
      </div>
    </ng-template>

    <fgb-errors></fgb-errors>

    <ng-container *ngIf="loading">
      <div class="loading-transactions">
        <fgb-loading></fgb-loading>
      </div>
    </ng-container>
  </div>
</form>
